<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Billing Payment/History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Devices</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <ul class="package-nav">
          <li
            v-for="(item, index) in packageLevels"
            :key="index"
            :class="{ active: item.id == activeLevel }"
            @click="activate(item.id)"
            data-toggle="collapse"
            data-target=".multi-collapse"
            aria-expanded="false"
            aria-controls="Home"
          >
            {{ item.name }}
          </li>
          <span class="indicator-line"></span>
        </ul>

        <div
          v-for="(deviceList, index) in groupByCategory(devices)"
          class="collapse multi-collapse"
          :class="index.includes('audra-home') ? 'show audra-home' : ''"
          :id="index.includes('audra-home') ? 'home' : 'business'"
          :key="'tab_pane' + index"
        >
          <div class="row equal-height-row flex-wrap justify-content-center">
            <div
              class="col-sm-4 col-md-4 col-lg-4 col-xs-12 d-flex"
              v-for="(device, i) in deviceList"
              :key="'box_' + i"
            >
              <div class="audra-box">
                <!-- <img
                  v-bind:src="
                    getImage(
                      device.package_image != null
                        ? device.package_image
                        : 'audra-enterprise.png'
                    )
                  "
                  alt="audra"
                /> -->
                <img
                  v-if="!device.package_image.includes(' ')"
                  :src="getImage(device.package_image)"
                  alt="audra"
                />
                <img v-else src="/assets/images/dummyimage.svg" alt="service" />
                <h3>{{ device.service_name }}</h3>
                <p>
                  {{ device.short_description }}
                </p>
                <div
                  class="subscription-status"
                  v-if="device.service_name == 'Audra Homeshield'"
                >
                  <ul>
                    <li>
                      Subscription Date:
                      <span class="gradient-date"> 20 Oct 2023 </span>
                    </li>
                    <li>
                      Subscription Expired Date:
                      <span class="gradient-date"> 10 Nov 2023 </span>
                    </li>
                  </ul>
                </div>
                <ul v-else>
                  <li v-for="(obj, indx) in device.service_details" :key="indx">
                    {{ obj.desc }}
                  </li>
                </ul>
                <br />
                <div
                  v-if="device.service_name == 'Audra Homeshield'"
                  class="btn-row"
                >
                  <a @click="redirectTo" href="javascript:void(0);" class="btn"
                    >Manage</a
                  >
                </div>
                <div v-else class="btn-row">
                  <a
                    @click="redirectToOther"
                    href="javascript:void(0);"
                    class="btn btn-outline"
                    >Learn more</a
                  >
                  <a
                    @click="orderDevice(device.cbs_service_id)"
                    href="javascript:void(0)"
                    class="btn"
                    >Order now</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { Capacitor } from "@capacitor/core";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Devices",
  metaInfo: {
    title: "My Information | Dotlines",
  },
  components: {
    //
  },

  data: () => ({
    activeLevel: 1,
    packageLevels: [
      { id: 1, name: "Home" },
      { id: 2, name: "Business" },
    ],
    params: {},
    value: {},
    devices: {},
    isActive: false,
    is_loading: false,
    activeTab: "Home",
  }),

  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    const _this = this;
    _this.activeLevel = 1;
    _this.isActive = false;
    _this.param = _this.$route.params;
    _this.getAccountDetail(_this.param.id);
    _this.getDeviceDetail();
  },

  computed: {
    ...mapGetters(["profile"]),
  },

  methods: {
    ...mapActions(["FETCH_PROFILE"]),

    // getIMGPath(img) {
    //   return img ? require("@/assets/images/" + img) : "";
    // },

    activate(id) {
      this.activeLevel = id;
    },
    redirectToOther: function () {
      const redirectUrl = "https://audra.io/enterprises";
      if (!Capacitor.isNativePlatform()) {
        // window.location.href = redirectUrl;
        window.open(redirectUrl, "_blank");
      } else {
        // @ts-ignore
        const ref = cordova.InAppBrowser.open(
          redirectUrl,
          "_blank",
          "location=yes,hideurlbar=yes"
        );

        const myCallback = function (event) {
          console.log("Updated URL: ", event.url);
        };
        ref.addEventListener("loadstart", myCallback);
      }
    },

    redirectTo: function () {
      // console.log("Redirect URL::", redirectUrl);
      const redirectUrl = "https://manage.audra.io/login";
      if (!Capacitor.isNativePlatform()) {
        // window.location.href = redirectUrl;
        window.open(redirectUrl, "_blank");
      } else {
        // @ts-ignore
        const ref = cordova.InAppBrowser.open(
          redirectUrl,
          "_blank",
          "location=yes,hideurlbar=yes"
        );

        const myCallback = function (event) {
          console.log("Updated URL: ", event.url);
        };
        ref.addEventListener("loadstart", myCallback);
      }
    },

    handleTabClick: function () {},

    groupByCategory: function (listData) {
      console.log("List Data::", listData);
      const key = "package_category";
      const groups = {};
      if (Object.keys(listData).length !== 0) {
        for (const row of listData) {
          const cat = row.package_category;
          if (groups[cat]) {
            groups[cat].push(row);
          } else {
            groups[cat] = [];
            groups[cat].push(row);
          }
        }
        console.log("Grouped Data::", groups);
      }

      return groups;
    },

    orderDevice: function (id) {
      console.log("ID:::", id);
      const api_url = "/create_order_for_device";
      const _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      console.log("Subscriber::", subscriber);
      axios({
        method: "POST",
        url: api_url,
        data: {
          cbs_service_id: id,
          cuid: subscriber ? subscriber.username : null,
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          _this.$toaster.success(response.data.message);
          _this.is_loading = false;
          // _this.$router.push({ name: "Users" });
        })
        .catch((errors) => {
          console.log(errors.response.data);
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    getAccountDetail: function (id) {
      const api_url = "/get-account-info";
      const _this = this;
      _this.is_loading = true;
      axios
        .get(api_url)
        .then((response) => {
          console.log("response.data::", response.data);
          _this.value = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log("error " + error);
          _this.is_loading = false;
        });
    },

    getDeviceDetail: function () {
      const api_url = "/get_device_details";
      const _this = this;
      _this.is_loading = true;
      axios
        .get(api_url)
        .then((response) => {
          response.data = response.data.map((o) => {
            o.service_details = JSON.parse(o.service_details);
            return o;
          });
          console.log("response.data::", response.data);
          _this.devices = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log("error " + error);
          _this.is_loading = false;
        });
    },
  },
};
</script>
